import GrandmasterMentor from "../assets/images/badgeImages/Grandmaster_Mentor.png";
import SuperCertifiedMentor from "../assets/images/badgeImages/Super_Certified_Mentor.png";
import MasterCertifiedMentor from "../assets/images/badgeImages/Master_Certified_Mentor.png";
import SeniorGrandmasterMentor from "../assets/images/badgeImages/Senior_Grandmaster_Mentor.png";
import SupremeGrandmasterMentor from "../assets/images/badgeImages/Supreme_Grandmaster_Mentor.png";
import mentorDefaultBadge from "../assets/images/mentorDefaultBadge.png";
import certifiedMentorBadge from "../assets/images/certified.png";

export const days = [
  { text: "Monday", value: "mon" },
  { text: "Tuesday", value: "tue" },
  { text: "Wednesday", value: "wed" },
  { text: "Thursday", value: "thu" },
  { text: "Friday", value: "fri" },
  { text: "Saturday", value: "sat" },
  { text: "Sunday", value: "sun" },
];

export const MENTOR_PASSWORD_SKIP_LIMIT = 5;

export const getMentorBadgeDetails = (badgeId) => {
  if (badgeId === "" || badgeId === null) {
    return defaultBadgeDetails;
  } else if (Object.keys(mentorBadgeDetails).includes(badgeId)) {
    return mentorBadgeDetails[badgeId];
  } else {
    return defaultBadgeDetails;
  }
};

const defaultBadgeDetails = {
  name: "No Badge",
  badgeImg: mentorDefaultBadge,
  badgeInfo: ["Badge info not avaialbe"],
};

const mentorBadgeDetails = {
  CertifiedMentor: {
    name: "Certified Mentor",
    badgeImg: certifiedMentorBadge,
    badgeInfo: [
      "This badge signifies that the mentor has completed more than 200 hours of classes with Codeyoung",
      "This mentor has also maintained high quality with Class Ratings, Class Punctuality and Attendance throughout the Codeyoung tenure",
    ],
  },
  GrandmasterMentor: {
    name: "Grandmaster Mentor",
    badgeImg: GrandmasterMentor,
    badgeInfo: [
      "This badge is awarded upon completing 5,000+ hours of teaching.",
      "These mentors serve as pillars of the Codeyoung ecosystem, leading by example in teaching quality.",
      "They play a strategic role in mentor upskilling and curriculum evolution.",
      "They are frequently recognised for their consistency, leadership, and high impact on student learning.",
    ],
  },
  SuperCertifiedMentor: {
    name: "Super Certified Mentor",
    badgeImg: SuperCertifiedMentor,
    badgeInfo: [
      "This badge signifies that the mentor has completed over 1,250 hours of classes.",
      "They consistently uphold teaching excellence with positive student feedback and timely class conduct.",
      "The mentor actively engages with the mentor community and shares feedback for academic enhancement.",
      "They also support junior mentors by sharing best practices.",
    ],
  },
  MasterCertifiedMentor: {
    name: "Master Certified Mentor",
    badgeImg: MasterCertifiedMentor,
    badgeInfo: [
      "The mentor has completed over 3,000 hours of classes at Codeyoung.",
      "They exhibit deep subject-matter expertise and maintain top-tier class quality and professionalism.",
      "The badge signifies long-standing commitment to Codeyoung’s teaching standards and values.",
      "These mentors are often involved in training, mentoring, and academic innovation.",
    ],
  },
  SeniorGrandmasterMentor: {
    name: "Senior Grandmaster Mentor",
    badgeImg: SeniorGrandmasterMentor,
    badgeInfo: [
      "Awarded for completing 7,500+ teaching hours, this badge represents exceptional dedication.",
      "These mentors embody academic excellence, regularly guiding both students and mentors alike.",
      "Their contribution spans content refinement, process improvement, and mentor evaluation.",
      "They are recognised across Codeyoung for their reliability and mentorship.",
    ],
  },
  SupremeGrandmasterMentor: {
    name: "Supreme Grandmaster Mentor",
    badgeImg: SupremeGrandmasterMentor,
    badgeInfo: [
      "This is the highest honor, awarded to mentors with 10,000+ hours of live classes.",
      "They are considered foundational leaders within the mentor community at Codeyoung.",
      "These mentors demonstrate unmatched commitment, excellence, and leadership.",
      "They actively influence strategic academic initiatives, shaping the learning experience at a systemic level.",
    ],
  },
};


export const TASK_CATEGORIES = {
  FEEDBACK: "Feedback",
  ESCALATION: "Escalation",
  TRAINING: "Training",
  PENDING_ACTION: "Pending Action",
  PAYOUT: "Payout",
  OTHERS: "Others",
};

export const transformFirstLetterToUpperCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}